import * as React from 'react';
import { Bars} from "react-loader-spinner";


const PageLoader = () => {
	return (
		<>
			 <div className="opacity-25 fixed inset-0 z-40 bg-black">
    <div className="flex justify-center  items-center h-full w-full"><Bars
      height="80"
      width="80"
      color="#4fa94d"
      ariaLabel="bars-loading"
      wrapperStyle={{}}
      wrapperClass=""
      visible={true}
    /></div>
  </div>	
		</>


	);
};
export default PageLoader;
